import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { first } from 'rxjs/operators';
import { SnackBarComponent } from '../components/snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private snackBar = inject(MatSnackBar);

  private readonly durationInSeconds = 5;

  constructor() { }

  openErrorSnackBar = (message: string, extraMessage: string = null, permanent?: boolean) => this.openSnackBar(message, extraMessage, ['error-snack'], permanent);

  openSuccessSnackBar = (message: string, extraMessage: string = null, permanent?: boolean) => this.openSnackBar(message, extraMessage, ['success-snack'], permanent);

  openErrorMultipleSnackBarInRow(errors: string[]) {
    if (!errors.length) return;

    const open = (error: string) => {
      this.openErrorSnackBar(error)
        .afterDismissed()
        .pipe(first())
        .subscribe((_) => {
          if (errors.length) {
            open(errors.shift());
          }
        });
    };

    open(errors.shift());
  }

  private openSnackBar(message: string, extraMessage: string, panelClass: string[] = [], permanent?: boolean): MatSnackBarRef<SnackBarComponent> {
    return this.snackBar.openFromComponent(SnackBarComponent, {
      duration: permanent ? undefined : this.durationInSeconds * 1000,
      panelClass: panelClass,
      data: {
        message: message,
        extraMessage: extraMessage,
      },
    });
  }
}
